import IconInfo from '@apollo/icons/default/IconInfo.svg';
import React from 'react';

import { ClickableText } from 'src/components/common/clickableText/ClickableText';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export const SubscriptionRegistrationInfoIcon = () => {
  return (
    <Tooltip
      interactive
      label={
        <span className="font-normal normal-case">
          A subscription registration is the request a client makes to subscribe
          to a specific data change.{' '}
          <ClickableText
            className="text-link hover:underline"
            as="a"
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.apollographql.com/docs/graphos/metrics/operations#operation-metrics"
          >
            Learn more.
          </ClickableText>
        </span>
      }
    >
      <span className="inline-flex items-center">
        <IconInfo className="text-icon-primary" />
      </span>
    </Tooltip>
  );
};
